import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { tryToChangePassword, tryToFetchMyAccountInfo  } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'

class UserSettingsPasswordForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      current_password: props.user.changePasswordForm.lastSubmit.current_password,
    }

    this.handleTryToChangePassword = this.handleTryToChangePassword.bind(this);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  handleTryToChangePassword(e){
    const { dispatch } = this.props;
    dispatch(tryToChangePassword({
      current_password: this.state.current_password,
      new_password: this.state.new_password,
      new_password_verify: this.state.new_password_verify
    }))
    if(e) e.preventDefault();
  }

  componentWillReceiveProps(newprops){
    const { user } = newprops;
    const { change } = this.props;

    if(new Date().getTime() - user.successfullyChangedPassword < 2000){
      this.setState({
        current_password: '',
        new_password: '',
        new_password_verify: '',
        updated: true
      })
      change('current_password', '');
      change('new_password', '');
      change('new_password_verify', '');
    }
  }


  render(){
    const { user } = this.props; 
    const state = this.state;

    let formDisabled = !state.current_password || !state.new_password || !state.new_password_verify;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleTryToChangePassword(e);
        }}>
          <CustomField 
            type="password"
            name="current_password"
            placeholder="current password"
            label="Current Password"
            onChange={(e) => {this.setState({current_password: e, updated: false}); }}
            serverErrors={user.changePasswordForm.errors.current_password}
            required={true}
            disabled={user.tryingToChangePassword}
          />

         <CustomField 
            type="password"
            name="new_password"
            placeholder="new password"
            label="New Password"
            onChange={(e) => {this.setState({new_password: e, updated: false}); }}
            serverErrors={user.changePasswordForm.errors.new_password}
            required={true}
            minLength={8}
            disabled={user.tryingToChangePassword}
          />

          <CustomField 
            type="password"
            name="new_password_verify"
            placeholder="password"
            label="New Password Again"
            onChange={(e) => {this.setState({new_password_verify: e, updated: false}); }}
            serverErrors={user.changePasswordForm.errors.new_password_verify}
            required={true}
            minLength={8}
            disabled={user.tryingToChangePassword}
          />
          <div className="list-right">
            {
              this.state.updated &&
              <span className="list-item text-success">
                Password successfully updated.
              </span>
            }
            <span className="list-item">
              <Button 
                size="medium" 
                disabled={formDisabled} 
                thinking={user.tryingToChangePassword} 
                successful={user.successfullyChangedPassword}
                failed={user.failedToChangedPassword}
                color="success" 
                display="Change Password" 
                submit={true}
                onClick={this.handleTryToChangePassword}
              />
            </span>
          </div>
        </form>
      </div>
    )
  }
}


UserSettingsPasswordForm = reduxForm({
  form: 'UserSettingsPasswordForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsPasswordForm)

UserSettingsPasswordForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {};
  
  return {
    user,
    initialValues
  }
})(UserSettingsPasswordForm);

export default UserSettingsPasswordForm;


// WEBPACK FOOTER //
// ./src/components/UserSettingsPasswordForm/UserSettingsPasswordForm.js